export default "__VITE_ASSET__PErejM7R__"